/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Search_Location_PlaceholderInputs */

const en_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Munich, Germany`)
};

const de_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. München, Deutschland`)
};

const fr_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Munich, Allemagne`)
};

const es_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Múnich, Alemania`)
};

const it_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Monaco di Baviera, Germania`)
};

const nl_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. Amsterdam, Nederland`)
};

const pl_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. Monachium, Niemcy`)
};

const fi_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. München, Saksa`)
};

const da_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. München, Tyskland`)
};

const sv_salary_search_location_placeholder = /** @type {(inputs: Salary_Search_Location_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. München, Tyskland`)
};

/**
* | output |
* | --- |
* | "e.g. Munich, Germany" |
*
* @param {Salary_Search_Location_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_search_location_placeholder = /** @type {((inputs?: Salary_Search_Location_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Search_Location_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_search_location_placeholder(inputs)
	if (locale === "fr") return fr_salary_search_location_placeholder(inputs)
	if (locale === "es") return es_salary_search_location_placeholder(inputs)
	if (locale === "it") return it_salary_search_location_placeholder(inputs)
	if (locale === "nl") return nl_salary_search_location_placeholder(inputs)
	if (locale === "pl") return pl_salary_search_location_placeholder(inputs)
	if (locale === "fi") return fi_salary_search_location_placeholder(inputs)
	if (locale === "da") return da_salary_search_location_placeholder(inputs)
	if (locale === "sv") return sv_salary_search_location_placeholder(inputs)
	return en_salary_search_location_placeholder(inputs)
});